import { addDoc, collection, getDocs, orderBy, query, serverTimestamp } from 'firebase/firestore';
import { encryptPayload } from '../lib/crypto';
import { db } from '../lib/firebase';

const COLLECTION = 'inquiries';

export async function submitInquiry({ name, phone, address }) {
  const secret = process.env.REACT_APP_INQUIRY_ENCRYPTION_KEY;
  const encryptedPayload = await encryptPayload({ name, phone, address }, secret);

  await addDoc(collection(db, COLLECTION), {
    version: 1,
    encryptedPayload: JSON.stringify(encryptedPayload),
    createdAt: serverTimestamp(),
  });
}

export async function fetchInquiries() {
  const snapshot = await getDocs(
    query(collection(db, COLLECTION), orderBy('createdAt', 'desc'))
  );

  return snapshot.docs.map((docSnap) => ({
    id: docSnap.id,
    ...docSnap.data(),
    createdAt: docSnap.data().createdAt?.toDate?.() ?? null,
  }));
}
